module.exports = __webpack_public_path__ + "img/item4-4.282cbc0c.png";